import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'attendance',
    lazy: async () => ({ Component: (await import('./AttendancePage')).AttendancePage }),
  },
];
